import { getDeliveryLocation, getShopLocation } from './storage';

const DEFAULT_SHOP_LABEL = 'Select';
const DEFAULT_DELIVERY_LABEL = 'Select';

export function syncStoreLocatorLabels() {
  const savedShop = getShopLocation();
  const savedDelivery = getDeliveryLocation();

  document.querySelectorAll('.js-store-locator-shop-label').forEach((element) => {
    const labelType = element.dataset.storeLocatorLabelType;

    if (labelType === 'pdp-postcode') return;

    if (labelType === 'pdp-name') {
      element.textContent = savedShop?.name ?? '';
      element.hidden = !savedShop?.name;
      return;
    }

    element.textContent = savedShop?.name ?? DEFAULT_SHOP_LABEL;
  });

  document.querySelectorAll('.js-store-locator-delivery-label').forEach((element) => {
    const labelType = element.dataset.storeLocatorLabelType;

    if (labelType === 'pdp-postcode') {
      element.textContent = savedDelivery?.postcode ?? savedDelivery?.query ?? '';
      element.hidden = !savedDelivery;
      return;
    }

    element.textContent = savedDelivery
      ? savedDelivery.postcode ?? savedDelivery.formatted ?? savedDelivery.query
      : DEFAULT_DELIVERY_LABEL;
  });
}
